import { createContext } from 'react';
import { useCreation } from 'ahooks';
import { createLenovoId } from '@iecf/core';

export const AppCoreContext = createContext<{
  lenovoId: ReturnType<typeof createLenovoId>;
}>({
  lenovoId: {} as ReturnType<typeof createLenovoId>,
});

export const AppCoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useCreation(() => {
    const lenovoId = createLenovoId({
      apiConfig: {
        baseURL: 'https://api.lenovo.com',
        timeout: 30 * 1000,
      },
      debug: false,
      onStepChanged: () => {},
      onError: () => {},
    });

    return { lenovoId };
  }, []);

  return <AppCoreContext.Provider value={value}>{children}</AppCoreContext.Provider>;
};
